<template>
<!--  <span>Поле для поиска</span>-->
<!--  <select v-model="searchField">-->
<!--    <option>Страна</option>-->
<!--    <option>Город</option>-->
<!--  </select>-->

<!--  <span>Значение для поиска </span>-->
<!--  <input type="text" v-model="searchValue">-->

  <EasyDataTable
      :headers="headers"
      :items="areas"
      :filter-options="filterOptions"
      fixed-header="true"
      rows-per-page="10"
      border-cell
      alternating
      buttons-pagination
  >
    <template #header-email="header">
      <div class="filter-column">
          <img src="../images/eglass-filter.png" class="filter-icon" @click.stop="showNameFilter=!showNameFilter">
        {{ header.text }}
        <div class="filter-menu" v-if="showNameFilter">
          <input v-model="nameCriteria"/>
        </div>
      </div>
    </template>

    <template #expand="item">
      <div style="padding: 15px">
        <p>{{ item.id }} Здесь можно попробовать вывести информацию о площадках 2 уровня</p>
      </div>
    </template>

    <!-- eslint-disable vue/valid-v-slot -->
    <template #item-data.area_name="item">
      <a>{{ item.data.area_name }}</a>
    </template>
  </EasyDataTable>
</template>

<script>
import axios from "axios";

//https://hc200ok.github.io/vue3-easy-data-table-doc/getting-started.html

export default {
  name: "CoordTable",
  data() {
    return {
      areas: [],
      searchField: '',
      searchValue: '',
      nameCriteria: '',
      showNameFilter: false,
      headers: [
        { text: "Координатор", value: "coordinator" },
        { text: "E-mail представителя организации", value: "email" },
        { text: "Телефон представителя организации", value: "phone" },
        { text: "Наименование организации", value: "data.firm_name" },
        { text: "Фамилия представителя организации", value: "data.lastname" },
        { text: "Имя представителя организации", value: "data.firstname" },
        { text: "Отчество представителя организации", value: "data.surname" },
        { text: "Должность представителя организации", value: "data.dolzhnost" },
        { text: "Страна", value: "data.country", sortable: true },
        { text: "Город", value: "data.city" },
        { text: "Регион", value: "data.region" },
        { text: "Поселок", value: "data.selo" },
        { text: "Адрес", value: "data.area_address" },
        { text: "Сайт", value: "data.site" },
      ]
    }
  },
  mounted: function () {
    if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
      alert("Эта страница может работать некорректно в браузере Safari. Рекомендуемые браузеры Яндекс.Браузер или Google Chrome.");
    }
    this.getData();
  },
  methods: {
    async getData() {
      const areaResponse = await axios.get('/areas/get/all', {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      });
      this.areas = areaResponse.data;
    }
  },
  computed: {
    filterOptions() {
      const filterOptionsArray = [];
      // filterOptionsArray.push({
      //   field: 'age',
      //   comparison: 'between',
      //   criteria: ageCriteria.value,
      // });

      filterOptionsArray.push({
        field: 'email',
        criteria: this.nameCriteria,
        comparison: (value, criteria) => (value != null && criteria != null &&
            typeof value === 'string' && value.includes(`${criteria}`)),
      });

      return filterOptionsArray;
    }
  }
}
</script>

<style scoped>
.filter-icon {
  width: 15px;
  height: 15px;
  margin-right: 4px;
  cursor: pointer;
  display: inline-block;
}
</style>